import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';
import DashboardLayout from './dashboardLayout';
export default function DashboardDrawer({ item, textColor }) {
  // const [collapse, setCollapse] = useState("");

  // const handleSetCollapse = (name) => (collapse === name ? setCollapse(false) : setCollapse(name));
  const [submenu, setSubmenu] = useState(false);
  const showSubMenu = () => {
    setSubmenu(!submenu);
  };

  return (
    <DashboardLayout sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Gene20Box>
        <List>
          <ListItem
            mx={1}
            p={1}
            sx={{
              display: 'flex',
              justifyContent: 'left',
              alignItems: 'left',
            }}
            onClick={item.collapse && showSubMenu}
          >
            <ListItemButton
              component={MenuItem}
              onClick={showSubMenu}
              sx={{ display: 'flex', justifyContent: 'space-evenly' }}
            >
              <ListItemIcon sx={{ color: 'light' }}>{item.icon}</ListItemIcon>
              <ListItemText align="left">
                <Typography
                  color={textColor}
                  display="block"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  {item.name}
                </Typography>
              </ListItemText>
              <ListItemIcon sx={{ color: 'white' }}>
                {item.collapse && submenu ? item.iconOpen : item.collapse ? item.iconClosed : null}
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
        </List>
      </Gene20Box>
      <Gene20Box>
        <Collapse in={item.collapse && showSubMenu}>
          <List>
            {submenu &&
              item.collapse.map((item, index) => (
                <ListItem
                  align="right"
                  sx={{
                    pl: '2vh',
                    display: 'flex',
                    justifyContent: 'right',
                    alignItems: 'right',
                  }}
                >
                  <Gene20Box
                    component={Link}
                    to={item.route}
                    display="flex"
                    alignItems="center"
                    sx={{ cursor: 'pointer', userSelect: 'none' }}
                  >
                    <ListItemButton
                      component={MenuItem}
                      onClick={showSubMenu}
                      sx={{ display: 'flex', justifyContent: 'space-evenly' }}
                    >
                      <ListItemIcon
                        sx={{
                          // color: ({ palette: { white, secondary } }) =>
                          //   light ? white.main : secondary.main,
                          verticalAlign: 'middle',
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        sx={{
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'right',
                          justifyContent: 'right',
                        }}
                      >
                        <Typography
                          key={index}
                          color={textColor}
                          // display="block"
                          variant="caption"
                          fontWeight="lighter"
                          textTransform="uppercase"
                          sx={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '0.7rem',
                          }}
                        >
                          {item.name}
                        </Typography>
                      </ListItemText>
                    </ListItemButton>
                  </Gene20Box>
                </ListItem>
              ))}
          </List>
        </Collapse>
      </Gene20Box>
    </DashboardLayout>
  );
}
